const agent = {
  getlist: 'agent/getlist-by-admin',
  get: 'agent/get-by-admin',
  add: 'agent/add-by-admin',
  update: 'agent/update-by-admin',
  accept: 'agent/accept',
  reject: 'agent/reject',
  setverified: 'agent/set-verified',
  remove: 'agent/remove',
}
export default agent
